import axios from 'axios'
import store from '@state/store'

export default (routeTo, routeFrom, next) => {
  const { bookingId, lastName } = routeTo.query
  const { permalink } = routeTo.params

  if (!bookingId || !lastName) {
    next({
      name: 'web-checkin',
      params: { permalink },
    })
  } else {
    axios
      .post('/api/v2/get-reservation', {
        bookingId,
        lastName,
        property: store.state.property.currentProperty.id,
      })
      .then((res) => {
        if (res.status === 201) {
          next({
            name: 'web-checkin',
            params: {
              permalink,
              alert: 'You have been check-in.',
            },
          })
        } else {
          axios
            .post('/api/v2/get_dropdown')
            .then((resDropdown) => {
              routeTo.params.layoutComponents = ['navbar', 'heroImg']
              routeTo.params.reservation = res.data
              routeTo.params.dropdown = resDropdown.data

              next()
            })
            .catch(() => {
              next({ name: '404', params: { resource: 'Dropdown' } })
            })
        }
      })
      .catch(() => {
        next({ name: '404', params: { resource: 'Reservation' } })
      })
  }
}
